<script lang="ts">
  import type { PrintSelectionPreviewRow } from "../../../../../../../../_shared/_logic/print-selection-preview"
  import LetterAppointmentTag from "../../../../../../_shared/_modules/letter-appointment-tag"
  let { row }: { row: PrintSelectionPreviewRow } = $props()
</script>
<LetterAppointmentTag {row} />
